import { HandshakeIcon } from "@xola/icons";
import { Badge, Tooltip } from "@xola/ui-kit";
import React from "react";
import { Seller } from "types";
import { SellerLogo } from "@/components/Common/SellerLogo";
import { useResource } from "@/hooks/useResource";

export const PartnerBadge = ({ isPackage = false }: { isPackage?: boolean }) => {
    return (
        <Badge color="secondary" className="flex-0 space-x-2">
            <HandshakeIcon />
            <span>Partner{isPackage ? " Package" : ""}</span>
        </Badge>
    );
};

interface PartnerSellerBadgeProps {
    sellerId: string;
}

export const PartnerSellerBadge = ({ sellerId }: PartnerSellerBadgeProps) => {
    const { data: seller } = useResource<Seller>(["users", sellerId]);

    if (!seller) {
        return null;
    }

    return (
        <Tooltip placement="top" content={<var data-var="partnerSellerName">{seller.name}</var>}>
            <Badge
                color="primary"
                size="small"
                icon={<SellerLogo seller={seller} size="small" />}
                className="!h-7 px-1 py-1"
                title={seller.name}
            >
                <span className="no-translate truncate pl-1">{seller.name}</span>
            </Badge>
        </Tooltip>
    );
};
